/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.validation.required\":[\"Minst ett valg er påkrevd.\"],\"checkbox-group.label.optional\":[\"Valgfri\"]}");
//# sourceMappingURL=messages.mjs.map